
namespace Nobox.Nobox {

    export class ContactPickerBulkAction extends Serenity.Extensions.BulkServiceAction {
        private errorMessage = [];
        public ListId: any;
        public Url: any;
        protected getParallelRequests() {
            return 1;
        }
        protected getBatchSize() {
            return 10;
        }
        showErrorMessage() {
            if (this.get_errorCount() != 0) {
                var message = "";
                this.errorMessage.forEach(x => {
                    message += `${x.id} = ${x.message}\n`;
                });
                Q.confirm(message, () => {
                    this.execute(this.errorMessage.map(x => x.id));
                }, {
                    title: `Sync DB Found ${this.get_errorCount()} Error. Process Sync DB Again?`,

                })
            }
        }
        showResults() {
            super.showResults();
            //this.showErrorMessage();
        }
        protected executeForBatch(batch) {
            //Q.serviceCall({
            //    blockUI: false,
            //    timeout: 600000,
            //    url: "/Services/Nobox/Contact/Save",
            //    request: batch,
            //    onSuccess: (res: any) => {
            //        var success = res.CustomData.Insert + res.CustomData.Update;
            //        var failed = res.CustomData.Failed;
            //        this.set_successCount(this.get_successCount() + success);
            //        this.set_errorCount(this.get_errorCount() + failed);
            //    },
            //    onError: response => {
            //        this.set_errorCount(this.get_errorCount() + batch.length);
            //    },
            //    onCleanup: () => this.serviceCallCleanup()
            //});
            Q.serviceCall({
                blockUI: false,
                service: this.Url,
                request: {
                    ListId: `${this.ListId}`,
                    ListContact: batch.toString()
                },
                onSuccess: (res: any) => {
                    var success = res.CustomData.Insert + res.CustomData.Update;
                    var failed = res.CustomData.Failed;
                    this.set_successCount(this.get_successCount() + success);
                    this.set_errorCount(this.get_errorCount() + failed);
                },
                onError: response => {
                    this.set_errorCount(this.get_errorCount() + batch.length);
                },
                error: (xhr, status, msg) => {
                    this.set_errorCount(this.get_errorCount() + batch.length)
                    this.errorMessage.push({
                        id: batch,
                        message: msg
                    });
                },
                onCleanup: () => this.serviceCallCleanup()
            })
            //$this.dialogClose();
        }
    }
}